import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useUnit} from 'effector-react';
import {$user} from '../../models/authModel/index.js';
import {
    $selectedUser,
    editUserFx,
    resetUserEv,
    submitUserEv,
    $userGroupsSelect
} from '../../models/adminModel/index.js';
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {MultiSelect} from 'primereact/multiselect';
import {InputSwitch} from 'primereact/inputswitch';

export default function EditUserModal() {
    const {t} = useTranslation()
    const submit = useUnit(submitUserEv)
    const resetUser = useUnit(resetUserEv)
    const loading = useUnit(editUserFx.pending)
    const user = useUnit($selectedUser)

    const curUser = useUnit($user)

    const groupsOptions = useUnit($userGroupsSelect)

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue
    } = useForm({
        values: {
            groups: user?.groups ?? [],
            is_staff: user?.isStaff ?? false,
            is_superuser: user?.isSuperuser ?? false,
        }
    })

    const groups = watch('groups')
    const isStaffToggle = watch('is_staff')
    const isSuperuserToggle = watch('is_superuser')

    const onSubmit = (data) => {
        submit(data)
    }

    const onCancel = () => {
        reset()
        resetUser()
    }

    return <Dialog visible={!!user}
                   className={'w-8'}
                   onHide={onCancel}
                   header={`${t('Редактирование пользователя')}: ${user?.username}`}
    >
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className={'formgrid grid'}>
                <div className={'field col-12'}>
                    <label htmlFor={'groups'} className={'font-bold block'}>{t('Роли пользователя')}</label>
                    <MultiSelect
                        {...register('groups')}
                        value={groups}
                        onChange={e => setValue('groups', e.value)}
                        inputId={'groups'}
                        name={'groups'}
                        options={groupsOptions}
                        optionValue={'value'}
                        optionLabel={'label'}
                        className={'w-6'}
                    />
                </div>
                <div className={'field col-4'}>
                    <label htmlFor={'is_staff'} className={'font-bold block'}>
                        {t('Администрация')}
                    </label>
                    <InputSwitch checked={isStaffToggle}
                                 onChange={(e) => setValue('is_staff', e.target.checked)}
                                 name={'is_staff'}
                                 inputId={'is_staff'}
                                 {...register('is_staff')}
                    />
                </div>
                {curUser?.is_superuser === true && <div className={'field col-4'}>
                    <label htmlFor={'is_superuser'} className={'font-bold block'}>
                        {t('Суперпользователь')}
                    </label>
                    <InputSwitch
                        checked={isSuperuserToggle}
                        onChange={(e) => setValue('is_superuser', e.target.checked)}
                        name={'is_superuser'}
                        inputId={'is_superuser'}
                        {...register('is_superuser')}
                    />
                </div>}
            </div>
            <div className={'flex gap-3'}>
                <Button icon="pi pi-check" label={t('Сохранить')} type={'submit'}
                        disabled={!user || loading} loading={loading}/>
                <Button icon="pi pi-times" label={t('Отмена')} severity={'warning'}
                        onClick={onCancel}/>
            </div>
        </form>
    </Dialog>
}